import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const SourceContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        const sorted = data.attendanceSource?.sort((a, b) => b.qty - a.qty);

        sorted.forEach((item) => {
            item.source === 'SOS' ? labels.push(item.source) : labels.push(ReportUtils.formatText(item.source));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Origem dos atendimentos");
        GraphicUtils.horizontalBarChart('attendance-source', values, labels, true);
    }, [data]);

    return (
        <>
            <div className="chart-report duo-bar-chart align-center">
                <div className="chart-title text-center mb-2">Origem dos atendimentos</div>
                <div className="chart-report" id="attendance-source"></div>
            </div>
        </>
    );
};

export default SourceContent;